import React, { Component } from "react";
import DevEnvironmentReviewForm from "./DevEnvironmentReviewForm";
import SmallModal from "../../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";

class DevEnvironmentReview extends Component {
  state = {
    proj_dev_enviornment_review_id: null
  };

  componentDidMount() {
    this.props.devEnvironmentReview.fetch();
  }
  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <DevEnvironmentReviewForm
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentDevEnvironmentReview={
              this.state.proj_dev_enviornment_review_id === null
                ? null
                : this.props.devEnvironmentReview.devEnvironmentReview.find(
                    devEnvironmentReview =>
                      devEnvironmentReview.proj_dev_enviornment_review_id ===
                      this.state.proj_dev_enviornment_review_id
                  )
            }
            update={this.props.devEnvironmentReview.update}
            add={this.props.devEnvironmentReview.add}
            projectID={this.props.currentProjectID}
            disabled={this.props.disabled}
          />
        </SmallModal>
      );
    }
    return (
      <div className="container-fluid">
        {smallModal}
        {this.props.disabled ? null : (
          <div style={{ textAlign: "right" }}>
            <Button
              className="my-2"
              color="blue"
              onClick={() => {
                this.setState({ proj_dev_enviornment_review_id: null });
                this.props.toggleSmallModalHandler();
              }}
            >
              Create New Dev Environment Review
            </Button>
          </div>
        )}

        <table className="table">
          <thead>
            <tr>
              <th>DEIS</th>
              <th>FEIS</th>
              <th>FONSI</th>
              <th>Notes</th>
              {this.props.disabled ? null : <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {this.props.devEnvironmentReview.devEnvironmentReview.map(item => (
              <tr
                key={item.proj_dev_enviornment_review_id}
                onClick={e => {
                  if (e.target.type !== "button") {
                    this.setState({
                      proj_dev_enviornment_review_id:
                        item.proj_dev_enviornment_review_id
                    });
                    this.props.toggleSmallModalHandler();
                  }
                }}
              >
                <td>{item.deis}</td>
                <td>{item.feis}</td>
                <td>{item.fonsi}</td>
                <td>{item.notes}</td>
                {this.props.disabled ? null : (
                  <td>
                    <Button
                      color="blue"
                      type="button"
                      onClick={() => {
                        this.setState({
                          proj_dev_enviornment_review_id:
                            item.proj_dev_enviornment_review_id
                        });
                        this.props.toggleSmallModalHandler();
                      }}
                    >
                      Edit
                    </Button>{" "}
                    <Button
                      color={"red"}
                      type="button"
                      onClick={() =>
                        this.props.devEnvironmentReview.delete(
                          item.proj_dev_enviornment_review_id,
                          this.props.currentProjectID
                        )
                      }
                    >
                      Delete
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default DevEnvironmentReview;
